import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import MasterAssesmentHistory from "./MasterAssesmentHistory";
import {getMasterAssessmentHistory} from "../../../services/redux/Training/action";

const mapStateToProps = (state) => ({
    testHistory: state.Training.assessmentMasterHistory
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getMasterAssessmentHistory
        },
        dispatch
    );


export default connect(mapStateToProps, mapDispatchToProps)(MasterAssesmentHistory);